import type { PythonCodeBlock } from '@jeraisonne/ai';

const INPUT =
  'w-full rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-400';

export function PythonCodeForm({
  block,
  onChange,
}: {
  block: PythonCodeBlock;
  onChange: (next: PythonCodeBlock) => void;
}) {
  const highlight = (block.highlightLines ?? []).join(', ');

  return (
    <div className="space-y-3">
      <div>
        <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-600">
          Code Python
        </label>
        <textarea
          rows={10}
          value={block.code}
          onChange={(e) => onChange({ ...block, code: e.target.value })}
          spellCheck={false}
          className="w-full resize-y rounded-lg border border-slate-200 px-3 py-2 font-mono text-[11px] focus:outline-none focus:ring-2 focus:ring-indigo-400"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <label className="flex items-center gap-2 text-xs text-slate-700">
          <input
            type="checkbox"
            checked={block.showLineNumbers !== false}
            onChange={(e) => onChange({ ...block, showLineNumbers: e.target.checked })}
            className="h-4 w-4 accent-indigo-600"
          />
          Numéros de ligne
        </label>
        <div>
          <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-600">
            Lignes surlignées
          </label>
          <input
            type="text"
            value={highlight}
            placeholder="ex. 2, 5, 6"
            onChange={(e) =>
              onChange({
                ...block,
                highlightLines: e.target.value
                  .split(',')
                  .map((s) => parseInt(s.trim(), 10))
                  .filter((n) => Number.isInteger(n) && n > 0),
              })
            }
            className={INPUT}
          />
        </div>
      </div>
    </div>
  );
}
